/**
 * Dependency Value Not String
 */

export default ['index', 'type', 'isBundle', 'isPackage'];
